import React from "react";
import { motion } from "framer-motion";

export const Stars = ({ rating = "4,6", count, size = 14 }) => (
  <span className="inline-flex items-center gap-2" style={{ fontSize: size }}>
    <span className="star" aria-hidden style={{ letterSpacing: "1px" }}>★★★★★</span>
    <span style={{ color: "var(--text-muted)", fontSize: size }}>
      {rating}/5{count != null ? ` · (${count} avis vérifiés)` : ""}
    </span>
  </span>
);

export const Badge = ({ children, testid }) => (
  <span className="crush-badge" data-testid={testid}>{children}</span>
);

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for kinetic hero
export const SplitReveal = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-line" style={{ display: "block" }}>
        <motion.span
          style={{ display: "block" }}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Marquee = ({ text }) => {
  const seg = ` ${text} · `;
  return (
    <div className="marquee section" style={{ padding: "22px 0" }} data-testid="marquee">
      <div className="marquee-track" style={{ fontFamily: "var(--display)", fontSize: 20, color: "var(--text-muted)" }}>
        {seg}{seg}{seg}{seg}
      </div>
      <div className="marquee-track" style={{ fontFamily: "var(--display)", fontSize: 20, color: "var(--text-muted)" }} aria-hidden>
        {seg}{seg}{seg}{seg}
      </div>
    </div>
  );
};


// Responsive image with automatic srcset (expects /media/crush-*.webp with -480/-960/-1440 variants)
export const Img = ({ src, alt, sizes = "100vw", style, className, ...rest }) => {
  const responsive = typeof src === "string" && /\/media\/crush-/.test(src) && src.endsWith(".webp");
  const base = responsive ? src.slice(0, -5) : null;
  const srcSet = responsive
    ? `${base}-480.webp 480w, ${base}-960.webp 960w, ${base}-1440.webp 1440w`
    : undefined;
  return (
    <img src={src} srcSet={srcSet} sizes={sizes} alt={alt} loading="lazy"
      style={style} className={className} {...rest} />
  );
};

export const ReviewCard = ({ review, testid }) => (
  <div className="card" style={{ padding: 22, height: "100%", display: "flex", gap: 14 }} data-testid={testid}>
    {review.photo && (
      <img src={review.photo} alt={review.name} loading="lazy"
        style={{ width: 56, height: 56, borderRadius: 4, objectFit: "cover", flexShrink: 0, border: "1px solid var(--border)" }} />
    )}
    <div style={{ flex: 1 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
        <span style={{ fontWeight: 600 }}>{review.name}</span><span className="star">★★★★★</span>
      </div>
      <h4 className="display" style={{ margin: "10px 0 6px", fontSize: 15 }}>{review.title}</h4>
      <p style={{ color: "var(--text-muted)", fontSize: 14, margin: 0 }}>{review.text}</p>
    </div>
  </div>
);
